<div style="display: flex; align-items: center">
  <p-menu #menu [model]="items" [popup]="true" />
  <p-button
    (onClick)="menu.toggle($event)"
    icon="pi pi-user"
    styleClass="rounded-button p-button-rounded p-button-icon-only"
  />
  <span class="text-sm font-medium ml-3 mr-6">{{ userName }}</span>
</div>
